import React, { Suspense, useEffect, useRef } from 'react';
import { useLocation, useRoutes } from 'react-router-dom';
import combinedRoutes from '@@/app/routes';
import { Toaster } from 'sonner';
import './app.scss';
import { Icon } from '@cloudscape-design/components';

export default function App() {
  const element = useRoutes(combinedRoutes);
  const skipLinkRef = useRef<HTMLButtonElement>(null);
  const hasFocusedSkip = useRef<boolean>(false);
  const location = useLocation();

  const handleSkipClick = () => {
    document.getElementById('main-content')?.focus();
  };

  useEffect(() => {
    const handleFirstTab = (e: KeyboardEvent) => {
      if (e.key === 'Tab' && !hasFocusedSkip.current) {
        e.preventDefault();
        skipLinkRef.current?.focus();
        hasFocusedSkip.current = true;
      }
    };

    window.addEventListener('keydown', handleFirstTab);
    return () => window.removeEventListener('keydown', handleFirstTab);
  }, []);

  useEffect(() => {
    hasFocusedSkip.current = false;
  }, [location]);

  return (
    <div style={{ height: '100%' }}>
      <button ref={skipLinkRef} className='skip-link' onClick={handleSkipClick}>
        Skip to main content
      </button>

      <Toaster
        position='top-right'
        icons={{
          success: <Icon name='check' variant='success' />,
          error: <Icon name='close' variant='error' />
        }}
        toastOptions={{
          classNames: {
            success: 'toast-success',
            error: 'toast-error'
          }
        }}
      />

      <Suspense fallback={<div>Loading...</div>}>
        <main id='main-content' tabIndex={-1}>
          <div style={{ height: '48px', backgroundColor: '#000716' }}>&nbsp;</div>
          {element}
        </main>
      </Suspense>
    </div>
  );
}
